import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import { getCompanyProfileList, getCompanyModuleMapping, saveCompanyModuleMapping } from '../../services/user.service';
import { getAppModuleList, getAppSubModuleList, getModuleList, getSubModuleList } from '../../services/master.service';
import * as CryptoJS from "crypto-js";

import '../users/role.css';

export default function CompanyModuleMapping() {

    const [errMsg, setErrMsg] = useState('');
    const [success, setSuccess] = useState(false);
    const [companyId, setCompanyId] = useState('');
    const [ErrCompanyId, setErrCompanyId] = useState(false);
    const [disabled, setDisabled] = useState(false);

    const [modules, setModules] = useState([]);
    const [subModules, setSubModules] = useState([]);

    const [appModules, setAppModules] = useState([]);
    const [appSubModules, setAppSubModules] = useState([]);

    const [companies, setCompanies] = useState([]);
    const [activeTab, setActiveTab] = useState(1);

    const [modinfo, setModinfo] = useState({
        modls: [],
        response: [],
    });

    const [subModinfo, setSubModinfo] = useState({
        submodls: [],
        response: [],
    });

    const [app_modinfo, setAppModinfo] = useState({
        app_modls: [],
        response: [],
    });

    const [app_subModinfo, setAppSubModinfo] = useState({
        app_submodls: [],
        response: [],
    });

    // Track which module blocks are expanded (by "web-ID" or "app-ID" key)
    const [expandedModules, setExpandedModules] = useState({});

    const navigate = useNavigate();

    const validateTab1AndProceed = (targetTab) => {
        if (!companyId || companyId === "") {
            setErrCompanyId('Please select a company');
            return;
        } else {
            setErrCompanyId('');
        }
        setActiveTab(targetTab);
    };

    const handleTabChange11 = (tabNumber) => {
        if (activeTab === 1 && tabNumber !== 1) {
            validateTab1AndProceed(tabNumber);
        } else {
            setActiveTab(tabNumber);
        }
    };

    const useQuery = () => new URLSearchParams(useLocation().search);
    const query = useQuery();
    const compIdFromUrl = query.get('compid');

    useEffect(() => {
        let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
            'authToken': sessionStorage.getItem('LoggedInToken'),
        }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
        let oData = { 'token': EncryptData };

        getCompanyProfileList(oData).then(res => {
            if (res?.data?.data?.length) setCompanies(res.data.data);
        });

        getModuleList(oData).then(res => {
            if (res?.data?.data?.length) setModules(res.data.data);
        });

        getSubModuleList(oData).then(res => {
            if (res?.data?.data?.length) setSubModules(res.data.data);
        });

        getAppModuleList(oData).then(res => {
            if (res?.data?.data?.length) setAppModules(res.data.data);
        });

        getAppSubModuleList(oData).then(res => {
            if (res?.data?.data?.length) setAppSubModules(res.data.data);
        });

        if (compIdFromUrl) {
            const decryptedBytes = CryptoJS.AES.decrypt(compIdFromUrl.replace(/ /g, '+'), process.env.REACT_APP_ENCRYPT_SECRET_KEY);
            const decrypt_data = JSON.parse(decryptedBytes.toString(CryptoJS.enc.Utf8));
            setCompanyId(decrypt_data.company_id);
            fetchMapping(decrypt_data.company_id);
        }
    }, []);

    const fetchMapping = (compId) => {
        if (!compId) return;
        let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
            'param_data': { 'company_id': compId },
            'company_id': compId,
            'authToken': sessionStorage.getItem('LoggedInToken'),
        }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
        let oData = { 'token': EncryptData };

        getCompanyModuleMapping(oData).then(res => {
            if (res?.data?.data?.length) {
                const mapping = res.data.data[0];
                setModinfo({
                    modls: mapping.module_id && mapping.module_id !== "" ? mapping.module_id.split(',').map(Number) : [],
                    response: mapping.module_id && mapping.module_id !== "" ? mapping.module_id.split(',').map(Number) : [],
                });
                setSubModinfo({
                    submodls: mapping.sub_module_id && mapping.sub_module_id !== "" ? mapping.sub_module_id.split(',').map(Number) : [],
                    response: mapping.sub_module_id && mapping.sub_module_id !== "" ? mapping.sub_module_id.split(',').map(Number) : [],
                });
                setAppModinfo({
                    app_modls: mapping.app_module_id && mapping.app_module_id !== "" ? mapping.app_module_id.split(',').map(Number) : [],
                    response: mapping.app_module_id && mapping.app_module_id !== "" ? mapping.app_module_id.split(',').map(Number) : [],
                });
                setAppSubModinfo({
                    app_submodls: mapping.app_sub_module_id && mapping.app_sub_module_id !== "" ? mapping.app_sub_module_id.split(',').map(Number) : [],
                    response: mapping.app_sub_module_id && mapping.app_sub_module_id !== "" ? mapping.app_sub_module_id.split(',').map(Number) : [],
                });
            } else {
                // Reset if no mapping found
                setModinfo({ modls: [], response: [] });
                setSubModinfo({ submodls: [], response: [] });
                setAppModinfo({ app_modls: [], response: [] });
                setAppSubModinfo({ app_submodls: [], response: [] });
            }
        });
    }

    const handleCompanyChange = (e) => {
        const compId = e.target.value;
        setCompanyId(compId);
        fetchMapping(compId);
    }

    /* ── expand / collapse toggle ─────────────────────────── */
    const toggleExpand = (key) => {
        setExpandedModules(prev => ({ ...prev, [key]: !prev[key] }));
    };

    /* ── module checkbox — also toggles all sub-modules ────── */
    const handleChange = (e, subMdlData) => {
        const { value, checked } = e.target;
        const moduleId = Number(value);
        const subIds = subMdlData.map(s => s.id);

        setModinfo(prev => ({
            ...prev,
            modls: checked ? [...prev.modls, moduleId] : prev.modls.filter(m => m !== moduleId),
            response: checked ? [...prev.response, moduleId] : prev.response.filter(m => m !== moduleId),
        }));

        setSubModinfo(prev => {
            const filtered = prev.submodls.filter(s => !subIds.includes(s));
            return {
                ...prev,
                submodls: checked ? [...filtered, ...subIds] : filtered,
                response: checked ? [...filtered, ...subIds] : filtered,
            };
        });
    };

    /* ── individual sub-module toggle ────────────────────────  */
    const handleSubMdlChange = (e) => {
        const { value, checked } = e.target;
        const subId = Number(value);
        setSubModinfo(prev => ({
            ...prev,
            submodls: checked ? [...prev.submodls, subId] : prev.submodls.filter(s => s !== subId),
            response: checked ? [...prev.response, subId] : prev.response.filter(s => s !== subId),
        }));
    };

    /* ── app module checkbox — also toggles all app sub-modules */
    const handleAppModuleChange = (e, appSubMdlData) => {
        const { value, checked } = e.target;
        const moduleId = Number(value);
        const subIds = appSubMdlData.map(s => s.id);

        setAppModinfo(prev => {
            const updatedMods = checked ? [...(prev.app_modls || []), moduleId] : (prev.app_modls || []).filter(m => m !== moduleId);
            return { ...prev, app_modls: updatedMods, response: updatedMods };
        });

        setAppSubModinfo(prev => {
            const filtered = (prev.app_submodls || []).filter(s => !subIds.includes(s));
            const updated = checked ? [...filtered, ...subIds] : filtered;
            return { ...prev, app_submodls: updated, response: updated };
        });
    };

    /* ── individual app sub-module toggle ────────────────────  */
    const handleAppSubMdlChange = (e) => {
        const { value, checked } = e.target;
        const subId = Number(value);
        setAppSubModinfo(prev => {
            const updated = checked ? [...(prev.app_submodls || []), subId] : (prev.app_submodls || []).filter(s => s !== subId);
            return { ...prev, app_submodls: updated, response: updated };
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setErrCompanyId('');
        if (!companyId) {
            setErrCompanyId('Please select a company');
            return;
        }

        const obj = {
            company_id: companyId,
            module_id: modinfo.modls.join(','),
            sub_module_id: subModinfo.submodls.join(','),
            app_module_id: app_modinfo.app_modls.join(','),
            app_sub_module_id: app_subModinfo.app_submodls.join(','),
        };

        let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
            'param_data': obj,
            'authToken': sessionStorage.getItem('LoggedInToken'),
        }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
        let oData = { 'token': EncryptData };

        saveCompanyModuleMapping(oData).then(res => {
            if (res.data.errors) {
                setErrMsg(res.data.message);
                setSuccess(false);
            } else {
                setSuccess(res.data.message);
                setErrMsg('');
            }
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }).catch(err => {
            setErrMsg('Failed to save mapping');
            window.scrollTo({ top: 0, behavior: 'smooth' });
        });
    }

    /* ── selection count summary helpers ─────────────────────  */
    const webModCount = modinfo.modls.length;
    const webSubCount = subModinfo.submodls.length;
    const appModCount = (app_modinfo.app_modls || []).length;
    const appSubCount = (app_subModinfo.app_submodls || []).length;
    const totalSelected = webModCount + webSubCount + appModCount + appSubCount;

    const modulesData = modules.map(item => ({
        id: item.id,
        module_name: item.module_name,
        subMdlData: subModules.filter(subitem => subitem.module_id === item.id).map(subitem => ({
            id: subitem.id,
            module_id: subitem.module_id,
            sub_module_name: subitem.sub_module_name,
        })),
    }));

    const appModulesData = appModules.map(item => ({
        id: item.id,
        module_name: item.module_name,
        appSubMdlData: appSubModules.filter(subitem => subitem.module_id === item.id).map(subitem => ({
            id: subitem.id,
            module_id: subitem.module_id,
            sub_module_name: subitem.sub_module_name,
        })),
    }));

    /* ── render module tree ───────────────────────────────────  */
    const renderModuleTree = (data, isApp = false) => {
        const items = data.length > 0 ? data : [];
        if (items.length === 0) return <div className="role-no-data">No modules available</div>;

        return items.map(option => {
            const subItems = isApp ? option.appSubMdlData : option.subMdlData;
            const expandKey = `${isApp ? 'app' : 'web'}-${option.id}`;
            const isExpanded = !!expandedModules[expandKey];
            const isModChecked = isApp
                ? (app_modinfo.app_modls || []).includes(Number(option.id))
                : (modinfo.modls || []).includes(Number(option.id));

            // Count how many sub-modules of this module are selected
            const selectedSubCount = subItems.filter(s =>
                isApp ? (app_subModinfo.app_submodls || []).includes(Number(s.id)) : (subModinfo.submodls || []).includes(Number(s.id))
            ).length;

            return (
                <div
                    className={`role-module-block${isExpanded ? ' role-module-block--open' : ''}`}
                    key={option.id}
                    id={`module-block-${expandKey}`}
                >
                    {/* Module header row */}
                    <div className="role-module-header">

                        {/* Checkbox */}
                        <label
                            className="role-checkbox-label role-module-label"
                            htmlFor={`${expandKey}-chk`}
                        >
                            <input
                                className="role-checkbox"
                                type="checkbox"
                                id={`${expandKey}-chk`}
                                name={isApp ? "app_modls" : "modls"}
                                value={option.id}
                                onChange={(e) => isApp
                                    ? handleAppModuleChange(e, subItems)
                                    : handleChange(e, subItems)}
                                checked={isModChecked}
                            />
                            <span className="role-checkmark"></span>
                            <span className="role-module-name">{option.module_name}</span>
                        </label>

                        {/* Right-side meta: selected pill + expand toggle */}
                        <div className="role-module-meta">
                            {selectedSubCount > 0 && (
                                <span className="role-selected-pill" title="Selected sub-modules">
                                    {selectedSubCount}/{subItems.length} selected
                                </span>
                            )}
                            {selectedSubCount === 0 && (
                                <span className="role-badge">{subItems.length} sub</span>
                            )}

                            {subItems.length > 0 && (
                                <button
                                    type="button"
                                    id={`toggle-${expandKey}`}
                                    className={`role-toggle-btn${isExpanded ? ' role-toggle-btn--open' : ''}`}
                                    onClick={() => toggleExpand(expandKey)}
                                    aria-expanded={isExpanded}
                                    aria-controls={`sublist-${expandKey}`}
                                    title={isExpanded ? 'Collapse sub-modules' : 'Expand sub-modules'}
                                >
                                    <span className="role-toggle-icon">+</span>
                                </button>
                            )}
                        </div>
                    </div>

                    {/* Sub-module list — animated expand/collapse */}
                    {subItems.length > 0 && (
                        <div
                            id={`sublist-${expandKey}`}
                            className={`role-submodule-list${isExpanded ? ' role-submodule-list--open' : ''}`}
                        >
                            {subItems.map(subitem => {
                                const isSubChecked = isApp
                                    ? (app_subModinfo.app_submodls || []).includes(Number(subitem.id))
                                    : (subModinfo.submodls || []).includes(Number(subitem.id));
                                return (
                                    <label
                                        className={`role-checkbox-label role-submodule-label${isSubChecked ? ' role-submodule-label--checked' : ''}`}
                                        htmlFor={`${isApp ? 'app' : 'web'}-sub-${subitem.id}`}
                                        key={subitem.id}
                                    >
                                        <input
                                            className="role-checkbox"
                                            type="checkbox"
                                            id={`${isApp ? 'app' : 'web'}-sub-${subitem.id}`}
                                            name={isApp ? "app_submodls" : "submodls"}
                                            value={subitem.id}
                                            onChange={isApp ? handleAppSubMdlChange : handleSubMdlChange}
                                            checked={isSubChecked}
                                        />
                                        <span className="role-checkmark role-checkmark--sub"></span>
                                        <span className="role-submodule-name">{subitem.sub_module_name}</span>
                                        {isSubChecked && <span className="role-submodule-tick">✓</span>}
                                    </label>
                                );
                            })}
                        </div>
                    )}
                </div>
            );
        });
    };

    const tabs = [
        { id: 1, label: 'Select Company', icon: '🏢' },
        { id: 2, label: 'Web Module', icon: '🌐' },
        { id: 3, label: 'App Module', icon: '📱' },
    ];

    return (
        <div id="role-container" className="role-container">
            <div className="role-header">
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <h2 className="role-title">
                        <span className="role-title-icon">🔗</span>
                        {compIdFromUrl ? 'Edit Company Mapping' : 'Company Module Mapping'}
                    </h2>
                    <button type="button" className="role-btn role-btn--secondary" style={{ padding: '6px 12px', fontSize: '14px', height: 'auto', margin: 0 }} onClick={() => navigate('/company-module-mapping-list')}>
                        📋 Map Listing
                    </button>
                </div>
                <p className="role-subtitle">Configure module permissions for the company</p>
            </div>

            {/* ── Selection summary bar ───────────────────────── */}
            {totalSelected > 0 && (
                <div id="role-selection-bar" className="role-selection-bar">
                    <span className="role-selection-bar-icon">📋</span>
                    <span className="role-selection-bar-label">Selected:</span>
                    {(webModCount > 0 || webSubCount > 0) && (
                        <span className="role-selection-chip role-selection-chip--web">
                            🌐 {webModCount} module{webModCount !== 1 ? 's' : ''}
                            {webSubCount > 0 && <> · {webSubCount} sub</>}
                        </span>
                    )}
                    {(appModCount > 0 || appSubCount > 0) && (
                        <span className="role-selection-chip role-selection-chip--app">
                            📱 {appModCount} module{appModCount !== 1 ? 's' : ''}
                            {appSubCount > 0 && <> · {appSubCount} sub</>}
                        </span>
                    )}
                    <span className="role-selection-total">{totalSelected} total</span>
                </div>
            )}

            {/* Alerts */}
            {success && (
                <div id="role-alert-success" className="role-alert role-alert--success">
                    <span className="role-alert-icon">✅</span> {success}
                </div>
            )}
            {errMsg && !success && (
                <div id="role-alert-error" className="role-alert role-alert--error">
                    <span className="role-alert-icon">⚠️</span> {errMsg}
                </div>
            )}

            {/* Tab Nav */}
            <div id="role-tabs" className="role-tabs">
                {tabs.map(tab => (
                    <button
                        key={tab.id}
                        id={`role-tab-${tab.id}`}
                        className={`role-tab-btn${activeTab === tab.id ? ' role-tab-btn--active' : ''}`}
                        onClick={() => handleTabChange11(tab.id)}
                        type="button"
                    >
                        <span className="role-tab-icon">{tab.icon}</span>
                        <span className="role-tab-label">{tab.label}</span>
                        {/* Show count badge on tab if something selected */}
                        {tab.id === 2 && (webModCount + webSubCount) > 0 && (
                            <span className="role-tab-count">{webModCount + webSubCount}</span>
                        )}
                        {tab.id === 3 && (appModCount + appSubCount) > 0 && (
                            <span className="role-tab-count">{appModCount + appSubCount}</span>
                        )}
                    </button>
                ))}
            </div>

            <form id="role-form" onSubmit={handleSubmit} className="role-form">

                {/* ── Tab 1: Role Details ─────────────────────── */}
                {activeTab === 1 && (
                    <div id="role-tab-panel-1" className="role-tab-panel">
                        <div className="role-field-group">
                            <div className="row">
                                <div className="col-md-6">
                                    <label className="role-field-label" htmlFor="role-company-select">
                                        Company Name <span className="role-required">*</span>
                                    </label>
                                </div>
                                <div className="col-md-6">
                                    <select
                                        id="role-company-select"
                                        className="role-select"
                                        onChange={handleCompanyChange}
                                        value={companyId}
                                    >
                                        <option value="">Select Company</option>
                                        {companies.length > 0
                                            ? companies.map(opt => (
                                                <option key={opt.company_id} value={opt.company_id}>{opt.company_name}</option>
                                            ))
                                            : <option value="">No Data</option>}
                                    </select>
                                    {ErrCompanyId && <span className="role-field-error">{ErrCompanyId}</span>}
                                </div>
                            </div>
                        </div>

                        <div className="role-actions">
                            <button id="role-next-btn-1" type="button" className="role-btn role-btn--primary" onClick={() => validateTab1AndProceed(2)}>
                                Next <span>→</span>
                            </button>
                        </div>
                    </div>
                )}

                {/* ── Tab 2: Web Module ───────────────────────── */}
                {activeTab === 2 && (
                    <div id="role-tab-panel-2" className="role-tab-panel">
                        <div className="role-module-section">
                            <div className="role-module-section-header">
                                <div>
                                    <h4 className="role-module-section-title">🌐 Web Modules</h4>
                                    <p className="role-module-section-desc">
                                        Check a module to select it. Click <strong>+</strong> to expand and pick individual sub-modules.
                                    </p>
                                </div>
                                {(webModCount + webSubCount) > 0 && (
                                    <div className="role-module-count-badge">
                                        <span className="role-module-count-num">{webModCount + webSubCount}</span>
                                        <span className="role-module-count-label">selected</span>
                                    </div>
                                )}
                            </div>
                            <div id="role-web-modules" className="role-module-tree">
                                {renderModuleTree(modulesData, false)}
                            </div>
                        </div>
                        <div className="role-actions">
                            <button id="role-next-btn-2" type="button" className="role-btn role-btn--secondary" onClick={() => handleTabChange11(1)}>
                                <span>←</span> Back
                            </button>
                            <button id="role-next-btn-2-fwd" type="button" className="role-btn role-btn--primary" onClick={() => handleTabChange11(3)}>
                                Next <span>→</span>
                            </button>
                        </div>
                    </div>
                )}

                {/* ── Tab 3: App Module ───────────────────────── */}
                {activeTab === 3 && (
                    <div id="role-tab-panel-3" className="role-tab-panel">
                        <div className="role-module-section">
                            <div className="role-module-section-header">
                                <div>
                                    <h4 className="role-module-section-title">📱 App Modules</h4>
                                    <p className="role-module-section-desc">
                                        Check a module to select it. Click <strong>+</strong> to expand and pick individual sub-modules.
                                    </p>
                                </div>
                                {(appModCount + appSubCount) > 0 && (
                                    <div className="role-module-count-badge">
                                        <span className="role-module-count-num">{appModCount + appSubCount}</span>
                                        <span className="role-module-count-label">selected</span>
                                    </div>
                                )}
                            </div>
                            <div id="role-app-modules" className="role-module-tree">
                                {renderModuleTree(appModulesData, true)}
                            </div>
                        </div>
                        <div className="role-actions">
                            <button id="role-back-btn-3" type="button" className="role-btn role-btn--secondary" onClick={() => handleTabChange11(2)}>
                                <span>←</span> Back
                            </button>
                            <button id="role-list-btn-3" type="button" className="role-btn role-btn--secondary" onClick={() => navigate('/company-module-mapping-list')}>
                                📋 Map Listing
                            </button>
                            <button id="role-save-btn" className="role-btn role-btn--save" disabled={disabled}>
                                💾 Save Mapping
                            </button>
                        </div>
                    </div>
                )}
            </form>
        </div>
    );
}
